/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "name": "Cat blocks extended",
  "description": "Get April Fools' Day features that weren't released in PotentiaMod editor for April Fools' Day 2026.",
  "credits": [
    {
      "name": "TheColaber",
      "link": "https://scratch.mit.edu/users/TheColaber/"
    },
    {
      "name": "GarboMuffin"
    },
    {
      "name": "笑小朗"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "info": [
    {
      "type": "notice",
      "text": "This is an extension for the \"Cat Blocks\" plugin and includes the core Cat Blocks plugin functionality; do not enable both the Cat Blocks plugin and this extension simultaneously.",
      "id": "watch"
    }
  ],
  "tags": [
    "rw",
    "theme",
    "new"
  ],
  "enabledByDefault": false,
  "incompatibleWith": ["cat-blocks"]
};
export default manifest;
